// T140 — Output languages for generated documents (cover letter, tailored CV
// summary, A/B variants). Mirrors backend/src/config/languages.js — keep the
// `code`s in sync. Scope: Denmark + Nordic + EU, matching the project's
// geographic focus. Default = English (the common case for Nordic/EU roles).

export const LANGUAGES = [
  { code: 'en', name: 'English', endonym: 'English', flag: '🇬🇧' },
  { code: 'da', name: 'Danish', endonym: 'Dansk', flag: '🇩🇰' },
  { code: 'sv', name: 'Swedish', endonym: 'Svenska', flag: '🇸🇪' },
  { code: 'nb', name: 'Norwegian', endonym: 'Norsk', flag: '🇳🇴' },
  { code: 'fi', name: 'Finnish', endonym: 'Suomi', flag: '🇫🇮' },
  { code: 'de', name: 'German', endonym: 'Deutsch', flag: '🇩🇪' },
  { code: 'nl', name: 'Dutch', endonym: 'Nederlands', flag: '🇳🇱' },
  { code: 'fr', name: 'French', endonym: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Spanish', endonym: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italian', endonym: 'Italiano', flag: '🇮🇹' },
  { code: 'ro', name: 'Romanian', endonym: 'Română', flag: '🇷🇴' },
];

export const DEFAULT_LANGUAGE = 'en';

export function languageByCode(code) {
  return LANGUAGES.find((l) => l.code === code) ?? null;
}

// Sticky last-used choice so the picker remembers the operator's preference
// across recommendations. Falls back gracefully if storage is unavailable.
const STORAGE_KEY = 'hunter.docLanguage';

export function getPreferredLanguage() {
  try {
    const code = localStorage.getItem(STORAGE_KEY);
    return languageByCode(code) ? code : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export function setPreferredLanguage(code) {
  try {
    if (languageByCode(code)) localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* ignore — preference is a nicety, not load-bearing */
  }
}
